var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.584)",
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.473 5.634a3.734 3.734 0 0 0-3.422-3.718A3.733 3.733 0 0 0 2.803 9.25v3.817a.934.934 0 0 0 1.868 0V9.25a3.733 3.733 0 0 0 2.802-3.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98 9.332c.487-.068.957-.231 1.381-.481l3.056 3.052a.935.935 0 0 0 1.32-1.32L10.68 7.531a3.73 3.73 0 0 0-.56-4.522 3.74 3.74 0 0 0-4.52-.61"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.737,
    cy: 5.168,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.737 4.235V1.4a1.4 1.4 0 0 1 2.802 0v.615"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeys);
export default __webpack_public_path__ + "static/media/keys.92e56361.svg";
export { ForwardRef as ReactComponent };